import {useApi} from "../Api";
import {
    ExceptionListGroupLocationProductCodeFilters,
    ExceptionListProductCodeLocationGroupEntityRequest,
    ExceptionListProductCodeLocationGroupEntityResponse
} from "../types/exceptionListProductCodeLocationGroup";
import {buildQueryParams} from "../../utils";

export const useExceptionListProductCodeLocationGroupRepository = () => {
    const {GET, POST} = useApi();

    const PATH = "/pricing/exception-list-product-code-location-group";

    function getAssociationWithFilters({filters}: { filters: ExceptionListGroupLocationProductCodeFilters }): Promise<any> {
        const queryString = "?";

        const queryParams = buildQueryParams(filters);

        return GET(`${PATH}${queryString}${queryParams}`);
    }

    function getAssociations(exceptionListId: number): Promise<ExceptionListProductCodeLocationGroupEntityResponse[]> {
        return GET(`${PATH}/by-exception-list?exceptionListId=${exceptionListId}`);
    }

    function postExceptionListProductCodeLocationGroupAll(exceptionListProductCodeLocationGroupEntityRequest: ExceptionListProductCodeLocationGroupEntityRequest): Promise<ExceptionListProductCodeLocationGroupEntityRequest> {
        return POST(`${PATH}/new-association`, exceptionListProductCodeLocationGroupEntityRequest);
    }


    return {
        getAssociations,
        postExceptionListProductCodeLocationGroupAll
    };
};